import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CardComponent } from '@vectronic/ui';
import { CDN_HOST } from '../cdn-host.injection';
import { ElasticBeltsDialogContentComponent } from './elastic-belts-dialog-content.component';

@Component({
  selector: 'vectronic-formly-two-housing-collar-elastic-belts-info',
  imports: [CardComponent, ElasticBeltsDialogContentComponent],
  template: `
    <vectronic-card [title]="data.title" [displayClose]="true" (closed)="dialogRef.close()">
      <ng-container body>
        <div class="card-body">
          <div md-dialog-content class="content">
            <vectronic-formly-elastic-belts-dialog-content [data]="collarData" />
          </div>
        </div>
      </ng-container>
    </vectronic-card>
  `,
  styles: ``,
})
export class TwoHousingCollarElasticBeltsInfoDialogComponent {
  cdnHost = inject(CDN_HOST);
  dialogRef = inject(MatDialogRef<TwoHousingCollarElasticBeltsInfoDialogComponent>);
  data: { title: string; content: string } = inject(MAT_DIALOG_DATA);
  collarData = [
    {
      label: 'Type 1',
      favorite: true,
      description:
        'The elastic belt consists of the actual collar belt and an elastic element. The elastic belt material is 30 mm wide and has an elasticity of 90%. The outer protection is made from a Teflon tube.',
      elements: [
        {
          label: 'Round',
          images: [
            {
              url: `${this.cdnHost}/assets/img/elastic-belts/two_housing_elastic_type_1_round.png`,
              alt: 'Type 1 Round Shape',
            },
            {
              url: `${this.cdnHost}/assets/img/elastic-belts/two_housing_elastic_type_1_round_detail.png`,
              alt: 'Type 1 Round Shape Details',
            },
          ],
        },
        {
          label: 'Oval-Round',
          images: [
            {
              url: `${this.cdnHost}/assets/img/elastic-belts/two_housing_elastic_type_1_oval-round.png`,
              alt: 'Type 1 Oval-Round Shape',
            },
            {
              url: `${this.cdnHost}/assets/img/elastic-belts/two_housing_elastic_type_1_oval-round_detail.png`,
              alt: 'Type 1 Oval-Round Shape Details',
            },
          ],
        },
        {
          label: 'Oval',
          images: [
            {
              url: `${this.cdnHost}/assets/img/elastic-belts/two_housing_elastic_type_1_oval.png`,
              alt: 'Type 1 Oval Shape',
            },
            {
              url: `${this.cdnHost}/assets/img/elastic-belts/two_housing_elastic_type_1_oval_detail.png`,
              alt: 'Type 1 Oval Shape Details',
            },
          ],
        },
      ],
    },
    {
      label: 'Type 2',
      favorite: false,
      description:
        'The elastic belt consists of the actual collar belt and an elastic element. The elastic belt material is 40 mm wide and has an elasticity of 80%. The outer protection is made from a Cordura tube.',
      elements: [
        {
          label: 'Round',
          images: [
            {
              url: `${this.cdnHost}/assets/img/elastic-belts/two_housing_elastic_type_2_round.png`,
              alt: 'Type 2 Round Shape',
            },
            {
              url: `${this.cdnHost}/assets/img/elastic-belts/two_housing_elastic_type_2_round_detail.png`,
              alt: 'Type 2 Round Shape Details',
            },
          ],
        },
        {
          label: 'Oval-Round',
          images: [
            {
              url: `${this.cdnHost}/assets/img/elastic-belts/two_housing_elastic_type_2_oval-round.png`,
              alt: 'Type 2 Oval-Round Shape',
            },
            {
              url: `${this.cdnHost}/assets/img/elastic-belts/two_housing_elastic_type_2_oval-round_detail.png`,
              alt: 'Type 2 Oval-Round Shape Details',
            },
          ],
        },
      ],
    },
  ];
}
